import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'
import DownloadFile from '@/core/utils/DownloadFile'

const URL_PATH = '/ata-registro-preco/api/public/adesao/solicitante'

class AdesaoPublicaApiClient {
	async salvarInformacoesSolicitante(objParam) {
		return await axios.post(`${URL_PATH}`, objParam)
	}

	async buscarInformacoesSolicitante(objParam) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/buscar`,
			filters: objParam,
		}).build()
		return await axios.get(url)
	}

	async buscarItensPorFiltro(filtro, paginacao, idSolicitacaoAdesao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/itens`,
			filters: { ...filtro, idSolicitacaoAdesao },
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async salvarItem(objParam) {
		return await axios.put(`${URL_PATH}/itens/salvar`, objParam)
	}

	async salvarAnexo(formData) {
		return await axios.post(`${URL_PATH}/anexo/enviar`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		})
	}

	async buscarAnexosPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/anexo`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(url)
	}

	async baixarAnexo(objParam) {
		const url = `${URL_PATH}/anexo/baixar/documentos/${objParam.idAnexo}/baixar`

		const response = await axios.get(url, {
			params: {
				idDocumento: objParam.idAnexo,
				tipoRegistroDocumento: objParam.tipoRegistroDocumento,
			},
			responseType: 'arraybuffer',
		})

		const headers = response.headers
		const filename = headers['content-disposition']
			? headers['content-disposition'].split('filename=')[1]
			: 'anexo.pdf'

		// Chama a função de download
		DownloadFile.downloadArrayBuffer(
			response.data,
			filename.replace(`.${headers.extension}`, ''),
			headers['content-type'],
			headers.extension || 'pdf',
		)
	}

	async excluirAnexo(objParam) {
		return await axios.delete(`${URL_PATH}/anexo/${objParam.idAnexo}/excluir`, {
			params: {
				idDocumento: objParam.idAnexo,
				tipoRegistroDocumento: objParam.tipoRegistroDocumento,
			},
		})
	}

	async enviarSolicitacaoAdesao(objParam) {
		return await axios.post(`${URL_PATH}/enviar`, objParam)
	}
}

export default new AdesaoPublicaApiClient()
